import Service from '@/views/supply-and-demand/service';
export default {
  data: () => {
    return {
      list: [],
      typeList: [],
      type: '',
      subType: 1
    };
  },
  created() {
    Service.getSubTypeList().then(res => {
      this.typeList = res;
    });
    this.getService();
  },
  methods: {
    getService() {
      Service.getDemandList({
        isRecommended: 1,
        subType: this.subType,
        limit: 10,
        skip: 0,
        type: this.type,
        tId: '66aaf74f247b9fffdb5eba08'
      }).then(res => {
        this.list = res.result;
      });
    },

    toDetail(item) {
      this.$router.push('/supply-and-demand/detail?id=' + item._id);
    },

    updateType(type) {
      this.type = type;
      this.getService();
    },

    updateActiveType(type) {
      this.subType = type;
      this.getService();
    },
    toMore() {
      this.$router.push('/supply-and-demand/list');
    }
  }
};

